import styled from "styled-components";

const StatsRow = styled.div`
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin: 12px 0;
`;

const StatChip = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    background-color: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 8px;
    padding: 10px 18px;
    min-width: 80px;
    text-align: center;
`;

const StatLabel = styled.span`
    font-size: 10px;
    color: rgba(255, 255, 255, 0.35);
    text-transform: uppercase;
    letter-spacing: 0.08em;
`;

const StatValue = styled.span`
    font-size: 22px;
    font-weight: 900;
    color: #fff;
    line-height: 1;
`;

const StatValueAccent = styled(StatValue)`
    color: rgb(163, 27, 27);
`;

const WinRateChip = styled(StatChip)`
    border-color: rgba(163, 27, 27, 0.4);
    background-color: rgba(163, 27, 27, 0.06);
`;

function WrestlerStats({ wrestlerData }: any) {
    const total = wrestlerData.fights_count ?? 0;
    const wins = wrestlerData.won_fights_count ?? 0;
    const winRate = total > 0 ? Math.round((wins / total) * 100) : 0;

    return (
        <StatsRow>
            <StatChip>
                <StatLabel>Match</StatLabel>
                <StatValue>{total}</StatValue>
            </StatChip>
            <StatChip>
                <StatLabel>Vittorie</StatLabel>
                <StatValueAccent>{wins}</StatValueAccent>
            </StatChip>
            <WinRateChip>
                <StatLabel>Win rate</StatLabel>
                <StatValueAccent>{winRate}%</StatValueAccent>
            </WinRateChip>
        </StatsRow>
    );
}

export default WrestlerStats;
